import { render, staticRenderFns } from "./LmsMyFeedSocial.vue?vue&type=template&id=2473fa0d&scoped=true"
import script from "./LmsMyFeedSocial.vue?vue&type=script&lang=js"
export * from "./LmsMyFeedSocial.vue?vue&type=script&lang=js"
import style0 from "./LmsMyFeedSocial.vue?vue&type=style&index=0&id=2473fa0d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2473fa0d",
  null
  
)

export default component.exports